import * as BaforPrefix from './baforprefix.js';
const validPrefixes = [
    BaforPrefix.KIWI,
    BaforPrefix.PMV,
    BaforPrefix.STEP,
    'urn:bafor:ubvonline:',
    'urn:ekid:',
];
/** Check whether the given variable conforms to the syntactic BAFOR rules */
export const isValidBafor = (b) => {
    if (typeof b !== 'string')
        return false;
    if (!/^urn:[a-zA-Z0-9:-]+$/.test(b))
        return false;
    return validPrefixes.some((prefix) => b.startsWith(prefix));
};
